import React from 'react';

import { FiltersContainer, Button, FiltersClearButton } from '@td/ui';
import { useNpCoordination } from '../context/NpCoordinationContext';
import NPFilter from './NPFilter';

const Filters = () => {
  const {
    filters,
    clearFilters,
    activePage,
    setActivePage,
    debouncedLoadItems
  } = useNpCoordination();

  const applyFiltersSearch = () => {
    setActivePage(1);
    debouncedLoadItems(filters, activePage);
  };

  return (
    <FiltersContainer label="Filter by:" className="filters">
      <NPFilter />
      <Button onClick={applyFiltersSearch}>
        Search
      </Button>
      <FiltersClearButton
        className="clear-all-button"
        onClick={() => clearFilters()}
      >
        Clear All
      </FiltersClearButton>
    </FiltersContainer>
  );
};

export default Filters;
